export default "__VITE_ASSET__b8017f4a__"